/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_NameInputs */

const vi_phase_name = /** @type {(inputs: Phase_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên giai đoạn`)
};

/**

* @param {Phase_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const phase_name = /** @type {((inputs?: Phase_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_phase_name(inputs)
});